// extracted by mini-css-extract-plugin
export default {"suggestions-div":"_suggestions-div_3IN4Jp"};